import { SvgScissors } from '@loomhq/lens';
import React from 'react';
import { useLayer } from 'react-laag';
import { connect, useSelector } from 'react-redux';

import { VIDEO_ENTER_TRIM_MODE } from 'constants/hotkeys';
import { SHOW_NEW_TRIMMING_FTUX } from 'constants/triggers';
import * as device from 'utilities/device';

import useFtux from 'hooks/useFtux';
import { selectHasStarted } from 'selectors/videoPlayer';

import TrimFtuxTooltip from './ftux-tooltip';
import CollapsibleSideButton from '../collapsible-side-button';
import { useShouldShowWaveform } from '../trim-tools/hooks';

import styles from './styles.module.less';

const TrimModeButton = ({
  onClick,
  enterTrimEnabled,
  isCollapsed,
  disabled,
  currentUserCanEdit,
}) => {
  const videoHasStarted = useSelector(selectHasStarted);
  const shouldShowWaveform = useShouldShowWaveform();

  const [ftuxEnabled, endFtux] = useFtux({
    triggerKey: SHOW_NEW_TRIMMING_FTUX,
    launchDate: '2021-09-13',
    maxDuration: { weeks: 4 },
  });

  const { triggerProps, layerProps, renderLayer } = useLayer({
    isOpen: ftuxEnabled,
    placement: 'left-start',
    triggerOffset: 20,
    auto: true,
  });

  const userCanEdit = currentUserCanEdit;

  const showFtux = ftuxEnabled && !videoHasStarted && shouldShowWaveform;

  if (ftuxEnabled) {
    const _oldOnClick = onClick;

    onClick = evt => {
      endFtux();
      _oldOnClick(evt);
    };
  }

  return (
    !device.isMobile &&
    userCanEdit && (
      <CollapsibleSideButton
        className={showFtux && styles.hasFtux}
        icon={<SvgScissors />}
        isCollapsed={isCollapsed}
        isDisabled={disabled || !enterTrimEnabled}
        onClick={enterTrimEnabled ? onClick : undefined}
      >
        <div {...triggerProps}>
          {renderLayer(
            <div
              className={`tooltip theme-dark ${styles.ftux}`}
              {...layerProps}
            >
              <TrimFtuxTooltip show={showFtux} dismissTooltip={endFtux} />
            </div>
          )}
          Trim video ({VIDEO_ENTER_TRIM_MODE[0]})
        </div>
      </CollapsibleSideButton>
    )
  );
};

const mapStateToProps = state => {
  const { player_ready, video } = state.share_video;

  const { processing_information = {} } = video;
  const { trim_id, trim_progress } = processing_information;

  // the user should be able to enter trim mode if the player is ready or if
  // a trim job is progressing
  const enterTrimEnabled =
    player_ready || (trim_id != null && trim_progress !== 100);

  return {
    enterTrimEnabled,
    currentUserCanEdit: video.currentUserCanEdit,
  };
};

export default connect(mapStateToProps)(TrimModeButton);
